import NavBar from "./NavBar";
import Content from "./Content";


const Layout = () => {
    const style = ({ isActive }) => ({
      fontWeight: isActive ? 'bold' : 'normal',
    });
  
    return (
      <>
        <NavBar style={style} />
        <Content />
      </>
    );
  };

export default Layout;

